import Component from './Component';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import mapStateToProps from './mapStateToProps';
export default withRouter(connect(mapStateToProps)(Component));
